import {type MediaCardType} from '@wandb/weave/common/types/media';

import {type MediaBrowserPanelConfig} from '../common';

/** The subset of panel config holding the per-media-type fit settings. */
export type MediaFitConfig = Pick<
  MediaBrowserPanelConfig,
  'actualSize' | 'fitToDimension' | 'videoActualSize'
>;

export type FitSettings = {
  actualSize: boolean;
  fitToDimension: boolean;
};

/**
 * The fit settings that apply to the given media type. Each fit setting is
 * scoped to a single media type (WB-36875): images are sized by the "Image fit
 * and resolution" setting (actualSize/fitToDimension), videos by the "Use
 * video original size" toggle (videoActualSize), and other media types by
 * neither.
 */
export function getFitSettingsForMediaType(
  config: MediaFitConfig,
  mediaType: MediaCardType
): FitSettings {
  if (mediaType === 'image') {
    return {
      actualSize: config.actualSize ?? false,
      fitToDimension: config.fitToDimension ?? false,
    };
  }
  if (mediaType === 'video') {
    return {
      actualSize: config.videoActualSize ?? false,
      fitToDimension: false,
    };
  }
  return {actualSize: false, fitToDimension: false};
}
